import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NotificationItem, NotificheService} from '../../../_services/notifiche.service';
import {Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {ModalController} from '@ionic/angular';
import {MovimentiService} from '../../../_services/movimenti.service';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {MovimentiCreateComponent} from '../../movimenti/movimenti-create/movimenti-create.component';

@Component({
    selector: 'app-centro-notifiche-popup',
    templateUrl: './centro-notifiche-popup.component.html',
    styleUrls: ['./centro-notifiche-popup.component.scss'],
    standalone: false
})
export class CentroNotifichePopupComponent  implements OnInit,OnDestroy {
  @Input() notifiche: Array<NotificationItem> = [];
  @Input() embedded = false;
  @Input() showEmpty = false;
  subscription?: Subscription;
  isOpen = false;
  constructor(
    private notificheService: NotificheService,
    private router: Router,
    private modalCtrl: ModalController,
    private movimentiService: MovimentiService,
    private organizzazioniService: OrganizzazioniService) { }

  ngOnInit() {
    if (this.embedded) {
      return;
    }
    this.subscription = this.notificheService.notificheAlert.subscribe((_notifiche) => this.notifiche = _notifiche);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  hasAction(notifica: NotificationItem): boolean {
    return typeof notifica.route === 'string' && notifica.route.trim().length > 0;
  }

  openNotification(notifica: NotificationItem) {
    this.notificheService.markAsRead(notifica.id);
    this.notificheService.clearPopup();

    if (!this.hasAction(notifica)) {
      return;
    }

    const movimentoId = this.extractMovimentoId(notifica.route!);
    if (movimentoId) {
      this.openMovimentoModal(movimentoId, notifica.route!);
      return;
    }

    this.router.navigateByUrl(notifica.route!);
  }

  private extractMovimentoId(route: string): number | null {
    try {
      const url = new URL(route, window.location.origin);
      const id = url.searchParams.get('movimentoId');
      return id ? +id : null;
    } catch {
      return null;
    }
  }

  private async openMovimentoModal(movimentoId: number, fallbackRoute: string) {
    try {
      const movimento = await this.movimentiService.getMovimentoAsync(
        this.organizzazioniService.organizzazioneId,
        movimentoId
      );
      const modal = await this.modalCtrl.create({
        component: MovimentiCreateComponent,
        componentProps: {movimento, isNew: false},
        backdropDismiss: false,
        cssClass: 'custom-modal'
      });
      await modal.present();
    } catch {
      this.router.navigateByUrl(fallbackRoute);
    }
  }
}
